export const DATA_ATTRIBUTES = {
  FORWARDED_SEPARATOR: 'data-forwarded-separator',
  FORWARDED_CONTENT: 'data-forwarded-content',
  USER_INPUT_AREA: 'data-user-input-area',
  EMAIL_SIGNATURE: 'data-email-signature',
} as const;

export const DATA_ATTRIBUTE_SELECTORS = {
  FORWARDED_SEPARATOR: '[data-forwarded-separator="true"]',
  FORWARDED_CONTENT: '[data-forwarded-content="true"]',
  USER_INPUT_AREA: '[data-user-input-area="true"]',
  EMAIL_SIGNATURE: '[data-email-signature="true"]',
  FORWARDED_CONTENT_OR_SEPARATOR:
    '[data-forwarded-content="true"], [data-forwarded-separator="true"]',
} as const;

export const ATTRIBUTE_VALUES = {
  TRUE: 'true',
  CONTENTEDITABLE: 'contenteditable',
  TABINDEX: 'tabindex',
  PLACEHOLDER: 'placeholder',
  CLASS: 'class',
} as const;

export const SCROLL_BEHAVIOR = {
  SMOOTH: 'smooth',
  AUTO: 'auto',
  INSTANT: 'instant',
} as const;

export const SCROLL_BLOCK = {
  START: 'start',
  CENTER: 'center',
  END: 'end',
  NEAREST: 'nearest',
} as const;

export const SCROLL_INLINE = {
  START: 'start',
  CENTER: 'center',
  END: 'end',
  NEAREST: 'nearest',
} as const;

import {
  KeyboardEventType,
  KeyboardKey,
  MouseEventType,
} from '@this+that/utils';

export const KEYBOARD_KEYS = {
  E: 'e',
  ESCAPE: KeyboardKey.ESCAPE,
} as const;

export const DOM_EVENTS = {
  CLICK: MouseEventType.CLICK,
  KEYDOWN: KeyboardEventType.KEYDOWN,
  KEYUP: KeyboardEventType.KEYUP,
  MOUSEDOWN: MouseEventType.MOUSEDOWN,
} as const;

export const EDITOR_TIMING = {
  FOCUS_DELAY_MS: 100,
} as const;
